import { render, staticRenderFns } from "./xunjiaGonggao.vue?vue&type=template&id=6dcce634&scoped=true&"
import script from "./xunjiaGonggao.vue?vue&type=script&lang=js&"
export * from "./xunjiaGonggao.vue?vue&type=script&lang=js&"
import style0 from "./xunjiaGonggao.vue?vue&type=style&index=0&id=6dcce634&lang=scss&scoped=true&"
import style1 from "./xunjiaGonggao.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcce634",
  null
  
)

export default component.exports